var TPA_DEV_STYLES_PREFIX = 'style.';
var PRIME_COLORS_REFERENCES = ['white/black', 'black/white', 'primery-1', 'primery-2', 'primery-3'];
var NON_PRIME_COLORS_PREFIX = 'color-';
function getColorReferenceByColorName(colorName) {
    var editorIndex = Number(colorName.split('_').pop());
    if (editorIndex <= 5) {
        return PRIME_COLORS_REFERENCES[editorIndex - 1];
    }
    if (editorIndex > 10) {
        return NON_PRIME_COLORS_PREFIX + "  " + (editorIndex - 10);
    }
}
function mapColors(siteColors, tpaColors) {
    var colorMap = {};
    var ref;
    // tslint:disable-next-line: prefer-for-of
    for (var i = 0; i < siteColors.length; i++) {
        ref = getColorReferenceByColorName(siteColors[i].name);
        siteColors[i].reference = ref;
        colorMap[ref] = siteColors[i];
    }
    for (var color in tpaColors) {
        if (tpaColors.hasOwnProperty(color)) {
            colorMap[TPA_DEV_STYLES_PREFIX + color] = tpaColors[color];
        }
    }
    return colorMap;
}
function mapFonts(fonts) {
    var mappedFonts = {};
    for (var font in fonts) {
        if (fonts.hasOwnProperty(font)) {
            mappedFonts[TPA_DEV_STYLES_PREFIX + font] = fonts[font];
        }
    }
    return mappedFonts;
}
function mapNumbers(numbers) {
    var mappedNumbers = {};
    for (var number in numbers) {
        if (numbers.hasOwnProperty(number)) {
            mappedNumbers[TPA_DEV_STYLES_PREFIX + number] = numbers[number];
        }
    }
    return mappedNumbers;
}
export default {
    getColorReferenceByColorName: getColorReferenceByColorName,
    mapColors: mapColors,
    mapFonts: mapFonts,
    mapNumbers: mapNumbers,
};
//# sourceMappingURL=templateUtils.js.map